module.exports = __webpack_public_path__ + "media/特定设备声-家电设备-儿童电动牙刷.3386170d.wav";